import gql from 'graphql-tag';

export default gql`
  query projectNameStatus($id: Int!) {
    project(id: $id) {
      id
      name
      status
    }
  }
`;
